module.exports = __webpack_public_path__ + "img/4_brendan_s.131511ad.png";